module.exports = __webpack_public_path__ + "img/_DSC7816.f896e3ec.jpg";